import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "mt-[10px] mb-[20px] flex items-center" }
const _hoisted_3 = { class: "flex flex-col flex-1 min-w-0 mr-2" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "text-[12px] text-gray-500 truncate" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 0,
  class: "text-center text-gray-500"
}
const _hoisted_9 = {
  key: 1,
  class: "text-center text-gray-500"
}

import {ref, onMounted, onUnmounted, computed} from 'vue';
// import MyTable from '@/components/Table/DataTable.vue';
import {post} from '@/api/api'
import { Literature } from './Table/interfaces';
// const tableRef = ref(); // 获取table组件实例


interface Props {
modelValue: any[];
formData?: {
    keywords?: string[];
    [key: string]: any;
};
isBack?: boolean; // 添加标记，用于判断是否是上一步
}

export default /*@__PURE__*/_defineComponent({
  __name: 'selectLiterature',
  props: {
    modelValue: {},
    formData: {},
    isBack: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const props = __props;

const getUniqueKey = (item: Literature) => `${item.name}-${item.source}`;
const selectedKeys = computed(() => new Set(props.modelValue.map(getUniqueKey)));

const inputValue = ref(props.formData?.keywords?.join(' + ') || '');
const pageNum = ref(1);
const hasMore = ref(true);
const loading = ref(false);
const scrollContainer = ref<HTMLDivElement | null>(null);

const list = ref<Literature[]>([]);

const handleCheckboxChange = (item: Literature, isChecked: boolean) => {
    const newModelValue = [...props.modelValue];
    const key = getUniqueKey(item);
    const itemIndex = newModelValue.findIndex(i => getUniqueKey(i) === key);

    if (isChecked) {
        if (itemIndex === -1) {
            newModelValue.push(item);
        }
    } else {
        if (itemIndex > -1) {
            newModelValue.splice(itemIndex, 1);
        }
    }
    emit('update:modelValue', newModelValue);
}

const handleKeywordClick = (keyword: string) => {
  inputValue.value = keyword;
  search();
};

const search = () => {
    pageNum.value = 1;
    hasMore.value = true;
    list.value = [];
    getListApi();
}

const getListApi = async () => {
    if (loading.value || !hasMore.value) return;
    
    // 如果是上一步，直接返回
    if (props.isBack && pageNum.value === 1) {
        return;
    }
    
    loading.value = true;
    try {
        const response = await post('/aiGenerate/literature', {
            "pageNum": pageNum.value,
            "pageSize": 10,
            "keywords": inputValue.value
        });
        console.log('API response:', response);
        
        // 获取实际的响应数据
        const responseData = response.data;
        console.log('Response data:', responseData);
        
        if (responseData && responseData.code === 0 && Array.isArray(responseData.data)) {
            console.log('Setting list with data:', responseData.data);
            const newItems = responseData.data;
            
            if (pageNum.value === 1) {
                list.value = newItems;
            } else {
                list.value = [...list.value, ...newItems];
            }

            if (newItems.length < 10) {
                hasMore.value = false;
            } else {
                pageNum.value++;
            }
            
            console.log('Updated list:', list.value);
        } else {
            console.error('Invalid response format:', responseData);
            hasMore.value = false;
        }
    } catch (error) {
        console.error('请求失败:', error);
        hasMore.value = false;
    } finally {
        loading.value = false;
    }
};

const handleScroll = () => {
    if (!scrollContainer.value) return;
    const { scrollTop, scrollHeight, clientHeight } = scrollContainer.value;
    if (clientHeight + scrollTop >= scrollHeight - 20) {
        getListApi();
    }
}

// 初始化时调用一次
onMounted(() => {
    console.log('Component mounted, calling getListApi');
    getListApi();
});

onUnmounted(() => {
    if (scrollContainer.value) {
        scrollContainer.value.removeEventListener('scroll', handleScroll)
    }
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_input, {
        modelValue: inputValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
        class: "mr-[12px] w-[200px]",
        placeholder: "请输入文献信息"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, { onClick: search }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode("查询")
        ])),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("span", null, "关键词：", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData?.keywords, (keyword) => {
        return (_openBlock(), _createBlock(_component_el_tag, {
          key: keyword,
          type: "primary",
          effect: "dark",
          class: "ml-[8px] cursor-pointer",
          onClick: ($event: any) => (handleKeywordClick(keyword))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(keyword), 1)
          ]),
          _: 2
        }, 1032, ["onClick"]))
      }), 128))
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      ref_key: "scrollContainer",
      ref: scrollContainer,
      class: "h-[360px] overflow-y-auto",
      onScroll: handleScroll
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: getUniqueKey(item),
          class: _normalizeClass(["flex justify-between border w-[100%] h-[65px] mb-[20px] p-[10px] rounded-sm", {
                'bg-[#e3eefb]': selectedKeys.value.has(getUniqueKey(item)),
                'border-[#409eff]': selectedKeys.value.has(getUniqueKey(item))
            }])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "text-[14px] font-medium truncate",
              title: item.name
            }, _toDisplayString(item.name), 9, _hoisted_4),
            _createElementVNode("div", _hoisted_5, _toDisplayString(item.author) + " - " + _toDisplayString(item.source) + " (" + _toDisplayString(item.date) + ") ", 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("a", {
              href: item.name_href,
              target: "_blank",
              class: "mr-[10px] text-[#409eff]"
            }, "查看", 8, _hoisted_7),
            _createVNode(_component_el_checkbox, {
              "model-value": selectedKeys.value.has(getUniqueKey(item)),
              label: "选择",
              size: "large",
              onChange: (checked) => handleCheckboxChange(item, checked)
            }, null, 8, ["model-value", "onChange"])
          ])
        ], 2))
      }), 128)),
      (loading.value && list.value.length > 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, "加载中..."))
        : _createCommentVNode("", true),
      (!hasMore.value && list.value.length > 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_9, "没有更多了"))
        : _createCommentVNode("", true)
    ], 32)), [
      [_directive_loading, loading.value && list.value.length === 0]
    ])
  ]))
}
}

})